import { Animated, Easing, Platform, View } from 'react-native';
import React, { useEffect, useRef } from 'react';

import { makeStyles } from '@providers/Theme';
import { Elmenus, Logo } from '@components/Logo';

type AnimatedLogoProps = {
  expanded: boolean;
};

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  elmenusWrapper: {
    marginLeft: 8,
    overflow: 'hidden',
  },
  elmenus: {
    height: 32,
    width: 93,
  },
}));

export const AnimatedLogo: React.FC<AnimatedLogoProps> = ({ expanded }) => {
  const styles = useStyles();
  const translateX = useRef(new Animated.Value(-94)).current;
  const opacity = useRef(new Animated.Value(0)).current;
  const width = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    const expand = () => {
      Animated.parallel([
        Animated.timing(translateX, {
          toValue: 0,
          duration: 300,
          useNativeDriver: true,
          easing: Easing.inOut(Easing.ease),
        }),
        Animated.timing(opacity, {
          toValue: 1,
          duration: 300,
          useNativeDriver: true,
          easing: Easing.inOut(Easing.ease),
        }),
        Animated.timing(width, {
          toValue: 93,
          duration: 300,
          useNativeDriver: true,
          easing: Easing.inOut(Easing.ease),
        }),
      ]).start();
    };

    const collapse = () => {
      Animated.parallel([
        Animated.timing(translateX, {
          toValue: -94,
          duration: 300,
          useNativeDriver: true,
          easing: Easing.inOut(Easing.ease),
        }),
        Animated.timing(opacity, {
          toValue: 0,
          duration: 300,
          useNativeDriver: true,
          easing: Easing.inOut(Easing.ease),
        }),
        Animated.timing(width, {
          toValue: 0,
          duration: 300,
          useNativeDriver: true,
          easing: Easing.inOut(Easing.ease),
        }),
      ]).start();
    };

    if (expanded) {
      expand();
    } else {
      collapse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expanded]);

  return (
    <View style={styles.root}>
      <View>
        <Logo height={32} />
      </View>
      <Animated.View
        style={[styles.elmenusWrapper, Platform.OS === 'web' && { width }]}>
        <Animated.View
          style={[styles.elmenus, { opacity, transform: [{ translateX }] }]}>
          <Elmenus height={32} />
        </Animated.View>
      </Animated.View>
    </View>
  );
};
